module.exports = __webpack_public_path__ + "static/media/circ-cross-thin-orange.f2e5991a.svg";